export default __webpack_public_path__ + "static/footer-logo-90-years-4ef86eee5abeccbe9fed49f53e3f1b01.png";